import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareLinkPopUpComponent } from './components/pop-ups/share-link/share-link-pop-up.component';
import { AddCalendarPopUpComponent } from './components/pop-ups/add-calendar/add-calendar-pop-up.component';
import { FormsModule } from '../@forms/forms.module';
import { MaterialModule } from './material.module';
import { SpecialMessagesPopUpComponent } from './components/pop-ups/special-messages/special-messages-pop-up.component';
import { SpecialMessagesPopUpListComponent } from './components/pop-ups/special-messages/special-messages-pop-up-list/special-messages-pop-up-list.component';
import { SpecialMessagePopUpPreviewComponent } from './components/pop-ups/special-messages/special-message-pop-up-preview/special-message-pop-up-preview.component';
import { SpecialMessagePopUpDetailedComponent } from './components/pop-ups/special-messages/special-message-pop-up-detailed/special-message-pop-up-detailed.component';
import { SpecialMessagePopUpHeaderComponent } from './components/pop-ups/special-messages/special-message-pop-up-header/special-message-pop-up-header.component';
import { SpecialMessagesPopUpListContainerComponent } from './components/pop-ups/special-messages/special-messages-pop-up-list-container/special-messages-pop-up-list-container.component';
import { StationCanceledPopUpComponent } from './components/pop-ups/station-canceled/station-canceled-pop-up.component';
import { AgencyContactInfoPopUpComponent } from './components/pop-ups/agency-contact-info/agency-contact-info-pop-up.component';
import { LocationUsePopUpComponent } from './components/pop-ups/location-use/location-use-pop-up.component';
import { CookiesPopUpComponent } from './components/pop-ups/cookies/cookies-pop-up.component';
import { ImageCarouselComponent } from './components/pop-ups/image-carousel/image-carousel.component';
import { CantFindUserLocationPopUpComponent } from './components/pop-ups/cant-find-user-location/cant-find-user-location-pop-up.component';
import { ErrorMessagePopUpComponent } from './components/pop-ups/error-message-pop-up/error-message-pop-up.component';
import { RequestSentPopUpComponent } from './components/pop-ups/request-sent/request-sent-pop-up.component';
import { StationNotActivePopUpComponent } from './components/pop-ups/station-not-active/station-not-active-pop-up.component';
import { RouteNotActivePopUpComponent } from './components/pop-ups/route-not-active/route-not-active-pop-up.component';
import { SiteIntroPopUpComponent } from './components/pop-ups/site-intro/site-intro-pop-up.component';
import { StopsChangedPopUpComponent } from './components/pop-ups/stops-changed/stops-changed-pop-up.component';



@NgModule({
  declarations: [
    ShareLinkPopUpComponent,
    AddCalendarPopUpComponent,
    SpecialMessagesPopUpComponent,
    SpecialMessagesPopUpListComponent,
    SpecialMessagePopUpPreviewComponent,
    SpecialMessagePopUpDetailedComponent,
    SpecialMessagePopUpHeaderComponent,
    SpecialMessagesPopUpListContainerComponent,
    StationCanceledPopUpComponent,
    AgencyContactInfoPopUpComponent,
    LocationUsePopUpComponent,
    CookiesPopUpComponent,
    ImageCarouselComponent,
    ErrorMessagePopUpComponent,
    CantFindUserLocationPopUpComponent,
    RequestSentPopUpComponent,
    StationNotActivePopUpComponent,
    RouteNotActivePopUpComponent,
    SiteIntroPopUpComponent,
    StopsChangedPopUpComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
  ]
})
export class PopUpModule { }
